import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface GarageBookingQuery {
    organization: Organization
}

export const GET_GARAGE_BOOKING = gql`
    query getGarageBooking(
        $id: ID
        $organization: ID!
        $appointmentsFrom: DateTimeTz
        $appointmentsTo: DateTimeTz
        $services: [ID]
        $premiumServices: [ID]
        $slug: String
        $offset: Int
        $limit: Int
        $brand: ID
        $generation: ID
        $motorization: ID
        $gearbox: ID
        $body: ID
        $mileage: Int
        $registrationDate: Date
        $subRepairs: [String]
        $equipments: [String]
    ) {
        organization(id: $organization) {
            id
            garages(
                id: $id
                appointmentsFrom: $appointmentsFrom
                appointmentsTo: $appointmentsTo
                services: $services
                premiumServices: $premiumServices
                slug: $slug
                offset: $offset
                limit: $limit
                brand: $brand
                calculation: {
                    services: $services
                    brand: $brand
                    generation: $generation
                    motorization: $motorization
                    mileage: $mileage
                    gearbox: $gearbox
                    body: $body
                    registration_date: $registrationDate
                    sub_repairs: $subRepairs
                    equipments: $equipments
                }
            ) {
                data {
                    id
                    calculation {
                        estimated_price
                        estimated_price_before_promotion
                        parts_price
                        parts {
                            name
                        }
                        labour_cost
                        labour_steps {
                            name
                        }
                        promotion {
                            description
                            gross_discount
                            formatted_discount_type
                            type
                            bonuses {
                                icon
                                name
                                description
                            }
                        }
                    }
                }
            }
        }
    }

`
